// api
import { fetchApi } from '@/api'
// actions
const papeleriaReportsAll = (context) => {
  let url = 'papeleria/reports'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('PAPELERIA_REPORTS_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const papeleriaReportsForm = (context) => {
  let url = 'papeleria/reports/create'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('PAPELERIA_REPORTS_FORM', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const papeleriaReportsShow = (context) => {
  let url = 'papeleria/reports'
  let data = {}
  return fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('PAPELERIA_REPORTS_SHOW', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

// actions
const papeleriaReportsCreate = (context) => {
  let url = 'papeleria/reports/create'
  let data = {}
  return fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('PAPELERIA_REPORTS_CREATE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const papeleriaReportsUpdate = (context) => {
  let url = 'papeleria/reports'
  let data = {}
  return fetchApi(url, data, 'PUT')
    .then((response) => {
      context.commit('PAPELERIA_REPORTS_UPDATE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const papeleriaReportsDelete = (context, payload) => {
  let url = 'papeleria/reports'
  console.log(payload)
  return fetchApi(url, payload, 'DELETE')
    .then((response) => {
      context.commit('PAPELERIA_REPORTS_DELETE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}
const papeleriaReportsDataUser = (context, array) => {
  let url = 'papeleria/datauser'
  let data = JSON.stringify(array)
  return fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('PAPELERIA_REPORTS_PERMISS_LIST', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const papeleriaReportslistRVD = (context, array) => {
  let url = 'papeleria/reporteRVD'
  let data = JSON.stringify(array)
  return fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('PAPELERIA_REPORTS_REPORTS_LIST', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const papeleriaReportslistRVDP = (context, array) => {
  let url = 'papeleria/reporteRVDP'
  let data = JSON.stringify(array)
  return fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('PAPELERIA_REPORTS_REPORTS_LIST', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const papeleriaReportslistRM = (context, array) => {
  let url = 'papeleria/reporteRM'
  let data = JSON.stringify(array)
  return fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('PAPELERIA_REPORTS_REPORTS_LIST', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}
const papeleriaReportslistReversion = (context, array) => {
  let url = 'papeleria/reporteReversion'
  let data = JSON.stringify(array)
  return fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('PAPELERIA_REPORTS_REPORTS_LIST', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const PapeleriarevertirCobro = (context, array) => {
  let url = 'papeleria/reporteRevDelete'
  return fetchApi(url, array, 'POST')
    .then((response) => {
      context.commit('PAPELERIA_REPORTS_DELETE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

export default {
  papeleriaReportsAll,
  papeleriaReportsForm,
  papeleriaReportsShow,
  papeleriaReportsCreate,
  papeleriaReportsUpdate,
  papeleriaReportsDelete,
  papeleriaReportsDataUser,
  papeleriaReportslistRVD,
  papeleriaReportslistRVDP,
  papeleriaReportslistRM,
  papeleriaReportslistReversion,
  PapeleriarevertirCobro
}



// WEBPACK FOOTER //
// ./src/store/modules/papeleria/reports/actions.js